module.exports = __webpack_public_path__ + "media/images/game/profil-c8dac89946f21fb2fa1d9f08132c550b.png";